module.exports = __webpack_public_path__ + "media/src/images/playstore-logo-dd53328436aa95a28dbf97bf077f23f3.png";